.summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--bc-margin-xs, 8px);
}

.summaryLabel {
  color: var(--bc-color-text-secondary, #5A7494);
  font-size: var(--bc-font-size, 14px);
  margin-right: 4px;
}

.summaryChip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 12px;
  background: var(--bc-color-fill-tertiary, #F6F6F3);
  color: var(--bc-color-text, #17191A);
  font-size: var(--bc-font-size-sm, 12px);
}

.summaryChipRemove {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-size: 10px; // sizes the anticon (1em svg)
}

// Mirrors FilterBar's Clear All button; duplicated locally so FilterSummary
// doesn't reach into FilterBar's stylesheet.
.clearAllButton {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--bc-color-text-secondary, #5A7494);
  font-size: var(--bc-font-size, 14px);
  padding: 4px 8px;

  &:hover {
    color: var(--bc-color-primary, #0092FF);
  }
}
